import View from './view';
export const PollAnswer = View;
